import { DataBean } from "../DataBean";

export class AddKpi extends DataBean {



    public async addKpiToDashBoard(idDashBoard: any, idKpi: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.bi.DashBoardKpi_addKpiToDashBoard_Number_Number", [idDashBoard, idKpi]);
    }

}